export default class FiltersFormModel {
    constructor(formFilters, filters) {
        Object.assign(this, formFilters);
        this.load(filters);
    }

    load(filters) {
        Object.keys(this).forEach((key) => {
            const filter = filters[key] && filters[key].filter;
            this[key] = filter.value;
        });
    }

    commit(filters) {
        Object.entries(this).forEach(([key, value]) => {
            const filter = filters[key] && filters[key].filter;
            if (filter) {
                filter.value = value;
            }
        });
    }

    getValues(filters) {
        return Object.keys(this).reduce((acc, key) => {
            const filter = filters[key] && filters[key].filter;
            if (filter && filter.getFilterValue) {
                Object.assign(acc, filter.getFilterValue(key));
            } else {
                acc[key] = filter.value;
            }
            return acc;
        }, {});
    }

    reset() {
        Object.keys(this).forEach((key) => {
            this[key] = null;
        });
    }
}
